import {Blue3, Green4} from "../../theme/styles";

import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {Chip, Typography} from "@mui/material";

import React from "react";

class BusinessProcessModelTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();
    };

    componentWillUnmount() {
        super.componentWillUnmount();
    };

    enterpriseComponentUpdateCompleted(ec) {
        super.enterpriseComponentInsertCompleted(ec)

        ec.invalidateChildren();
    }

    onRowDoubleClick = (params, e, details) => {
        const navigate = this.props.navigate;
        navigate("/project-plan/project-plan-detail", {
            state: {
                projectPlanUSID: this.state.buffer[params.row.id].get("USID")
            },
        });
        super.onRowDoubleClick(params);
    };

    getCellRenderer(name) {
        if (name === "Status Cell") {
            return this.renderStatusCell;
        }

        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Project Plan") {
            this.setState({renderTarget: "New Project Plan"});
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
    };

    renderStatusCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let status;
        let backgroundColor;
        let content = [];

        if (Array.isArray(this.state.buffer[params.row.id].get("Status"))) {
            let a = this.state.buffer[params.row.id].get("Status")
            if (a.find((element) => element === "Draft") !== undefined || (a.find((element) => element === "DRAFT") !== undefined)) {
                status = "DRAFT";
                backgroundColor = Blue3;
                content.push(<Chip id="1" label={status} size="small" style={{marginRight: "5px", fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: 1}}/>)
            }
            if (a.find((element) => element === "Approved") !== undefined || (a.find((element) => element === "APPROVED") !== undefined)) {
                status = "RELEASED";
                backgroundColor = Green4;
                content.push(<Chip id="2" label={status} size="small" style={{marginRight: "5px", fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: 1}}/>)
            }
        } else {
            if (this.state.buffer[params.row.id].get("Status") === "DRAFT" || this.state.buffer[params.row.id].get("Status") === "Draft") {
                status = "DRAFT";
                backgroundColor = Blue3;
                content.push(<Chip id="1" label={status} size="small" style={{fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: 1}}/>)
            } else if (this.state.buffer[params.row.id].get("Status") === "RELEASED") {
                status = "RELEASED";
                backgroundColor = Green4
                content.push(<Chip id="2" label={status} size="small" style={{fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: 1}}/>)
            } else {
                status = "--";
                content = <Typography style={{marginTop: "10px"}}>{status}</Typography>
            }
        }
        return (
            <div style={{marginTop: "-2px"}}>
                {content}
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(BusinessProcessModelTable)));